"use client"
import React, {useState} from 'react'
import {useTekstClient} from "../../../../hooks/useTekstClient";
import {useRouter} from "next/navigation";
import {useAxios} from "../../../../hooks/useAxios";
import { Button, Form } from "components/ui";

const initData = {
    contactpersoon: null,
    datum: null,
    email: null,
    bedrijf: null,
    aantalpersonen: 1,
    contactpersoon2: null,
    email2: null,

}

export const Aanmeldform = () => {

    const {post} = useAxios();
    const {tekst} = useTekstClient()
    const router = useRouter();

    const [inputData, setInputData] = useState(initData)
    const [errors, setErrors] = useState({})

    const datumOpties = [
        {id: 1, value: tekst('website:aanmeldform:right:choose:day:1')[0]},
        {id: 2, value: tekst('website:aanmeldform:right:choose:day:2')[0]},
    ]

    const requiredFields = ['bedrijf', 'contactpersoon', 'email', 'aantalpersonen', 'datum']

    const isSecondPerson = parseInt(inputData.aantalpersonen, 10) === 2

    const allRequiredFields = isSecondPerson
        ? [...requiredFields, 'contactpersoon2', 'email2']
        : requiredFields

    const isFormValid = allRequiredFields.every((field) => {
        const value = inputData[field]
        return value !== null && value !== undefined && String(value).trim() !== ''
    })

    function handleChange(event) {
        const {value, name} = event.target
        const updateData = {...inputData}
        updateData[name] = name === 'aantalpersonen' ? parseInt(value, 10) : value
        setInputData(updateData)
    }


    function handleClick() {
        const newErrors = {}
        allRequiredFields.forEach((field) => {
            const value = inputData[field]
            if (value === null || value === undefined || String(value).trim() === '') {
                newErrors[field] = true
            }
        })

        setErrors(newErrors)

        if (Object.keys(newErrors).length > 0) {
            return
        }

        const obj = {...inputData}

        if (!isSecondPerson) {
            obj.contactpersoon2 = null
            obj.email2 = null
        }

        obj.form = 'aanmelden_form_techdemoweek'

        post('event/aanmeldform', obj).then(() => {
            setInputData(initData)
            setErrors({})
            router.push('/')

        })
    }


    return <section className={`w-full`}>
        {/*Banner*/}
        <div>
            {/*Desktop: cropped cover banner*/}
            <div
                className={`aanmeldform-banner`}
                style={{
                    backgroundImage: "url('https://www.mkg.eu/api/wiki/14151/EN/media')",
                }}
            />
            {/*Mobile: full uncropped image, centered, with breathing room instead of a forced aspect box*/}
            <div className={`aanmeldform-banner-mobile-wrapper`}>
                <img
                    className={`aanmeldform-banner-mobile`}
                    src={'https://www.mkg.eu/api/wiki/14151/EN/media'}
                    alt={'MKG ERP'}
                />
            </div>
            <style jsx>{`
                .aanmeldform-banner {
                    width: 100%;
                    max-height: 500px;
                    aspect-ratio: 16 / 9;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: 75% center;
                }
                .aanmeldform-banner-mobile-wrapper {
                    display: none;
                }
                @media (max-width: 640px) {
                    .aanmeldform-banner {
                        display: none;
                    }
                    .aanmeldform-banner-mobile-wrapper {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        /* main-nav (#navigatie_hoofd) is position:fixed with height:100px and overlays
                           the top of the page, so we need to clear it explicitly here */
                        padding: 116px 8px 28px;
                        background-color: #0d2c4e;
                    }
                    .aanmeldform-banner-mobile {
                        display: block;
                        width: 100%;
                        max-width: 560px;
                        height: auto;
                    }
                }
            `}</style>
        </div>


        {/*FORM*/}
        <div className={'max-w-[1140px] mx-auto px-4 my-24'}>
            <div className={`flex flex-col lg:flex-row items-start justify-center gap-12`}>

                {/*LEFT*/}
                <div className={`w-full lg:max-w-[538px]`}>
                    <h1 className={`text-3xl`} dangerouslySetInnerHTML={{__html: tekst('website:aanmeldform:header', null, null, true)}}/>
                    <p className={`mt-4`}
                       dangerouslySetInnerHTML={{__html: tekst('website:aanmeldform:body', null, null, true)}}></p>
                </div>


                {/*RIGHT*/}
                <div className={`w-full lg:max-w-[538px]`}>
                    <p className={`mb-4`}
                       dangerouslySetInnerHTML={{__html: tekst('website:aanmeldform:right:header', null, null, true)}}></p>

                    <div className={`flex flex-col gap-2`}>

                        {/*Bedrijf*/}
                        <div className={``}>
                            <label>{tekst('website:aanmeldform:right:company')} *</label>
                            <Form.Control className={`h-9`} name={'bedrijf'} value={inputData.bedrijf ?? ''}
                                          onChange={(e) => {
                                              handleChange(e)
                                          }} type="text" required isInvalid={!!errors.bedrijf}/>
                        </div>
                        {/*Contactpersoon*/}
                        <div className={``}>
                            <label>{tekst('website:aanmeldform:right:contactperson')} *</label>
                            <Form.Control className={`h-9`} name={'contactpersoon'} value={inputData.contactpersoon ?? ''}
                                          onChange={(e) => {
                                              handleChange(e)
                                          }} type="text" required isInvalid={!!errors.contactpersoon}/>
                        </div>

                        {/*email*/}
                        <div className={``}>
                            <label>{tekst('website:aanmeldform:right:email')} *</label>
                            <Form.Control className={`h-9`} name={'email'} value={inputData.email ?? ''}
                                          onChange={(e) => {
                                              handleChange(e)
                                          }} type="email" required isInvalid={!!errors.email}/>
                        </div>

                        {/*aantal personen*/}
                        <div>
                            <label htmlFor="aantalpersonen">{tekst('website:aanmeldform:right:person:amount')} *</label>
                            <Form.Control
                                as={"select"}
                                className={`h-9`} //Opties zijn 1 of 2 personen
                                name={'aantalpersonen'}
                                value={inputData.aantalpersonen ?? 1}
                                onChange={(e) => {
                                    handleChange(e)
                                }}
                                required
                                isInvalid={!!errors.aantalpersonen}
                            >
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                            </Form.Control>
                        </div>

                        {/*tweede contactpersoon + email, alleen zichtbaar bij 2 personen*/}
                        {isSecondPerson && (
                            <>
                                {/*Contactpersoon 2*/}
                                <div className={``}>
                                    <label>{tekst('website:aanmeldform:right:contactperson2')} *</label>
                                    <Form.Control className={`h-9`} name={'contactpersoon2'} value={inputData.contactpersoon2 ?? ''}
                                                  onChange={(e) => {
                                                      handleChange(e)
                                                  }} type="text" required isInvalid={!!errors.contactpersoon2}/>
                                </div>

                                {/*email 2*/}
                                <div className={``}>
                                    <label>{tekst('website:aanmeldform:right:email2')} *</label>
                                    <Form.Control className={`h-9`} name={'email2'} value={inputData.email2 ?? ''}
                                                  onChange={(e) => {
                                                      handleChange(e)
                                                  }} type="email" required isInvalid={!!errors.email2}/>
                                </div>
                            </>
                        )}

                        {/*datum*/}
                        <div>
                            <label htmlFor="datum">{tekst('website:aanmeldform:right:choose:day')} *</label>
                            <Form.Control
                                as="select"
                                className={`h-9`}
                                name={'datum'}
                                value={inputData.datum ?? ''}
                                onChange={(e) => {
                                    handleChange(e)
                                }}
                                required
                                isInvalid={!!errors.datum}
                            >
                                <option value={'' } disabled>{tekst('website:aanmeldform:right:choose:day')}</option>
                                {datumOpties.map((opt) => (
                                    <option key={opt.id} value={opt.value}>{opt.value}</option>
                                ))}
                            </Form.Control>
                        </div>

                        <p className={``}
                           dangerouslySetInnerHTML={{__html: tekst('website:aanmeldform:right:terms')}}></p>

                        <Button disabled={!isFormValid} variant={'primary'} onClick={handleClick}
                                className={`btn`}>{tekst('website:aanmeldform:right:btn')}</Button>
                    </div>
                </div>
            </div>

        </div>
    </section>
}
